import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostCompletePartnerOnboardingFlowParams,
  TPostCompletePartnerOnboardingFlowResponse,
} from "./postCompletePartnerOnboardingFlow.schema";

export const postCompletePartnerOnboardingFlow = (axios: IAxiosInstance) => {
  return async (params: TPostCompletePartnerOnboardingFlowParams) => {
    const { whiteLabelID } = params;
    const response = await axios.noRetry.post<
      IApiResponse<TPostCompletePartnerOnboardingFlowResponse>
    >(`/api/partners/${whiteLabelID}/complete-onboarding-flow`);
    const resData = response.data;
    if (resData?.data?.success) {
      return {
        success: true,
        message: resData.data?.message,
      };
    }
    throw new Error("Something went wrong");
  };
};
